import { useFormik } from 'formik';
import React, { useEffect, useRef } from 'react'
import PageTitle from '../../../../components/partials/PageTitle'
import Select from '../../../../components/form/select/Select'
import * as yup from "yup";
// import { createCharge, resetChargeStatus } from '../../../../redux/slice/charges/chargesSlice';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MultiSelect from '../../../../components/form/select/MultiSelect';
import { createLifeCover, resetLifeCoverStatus } from '../../../../redux/slice/lifecover/lifecoverSlice';

const policies = [
    // { name: 'General Cover', id: '1'},
    { name: 'Savings Policy', id: '2'},
    { name: 'Credit Life', id: '3'},
]

const multipleData = [
    { name: 'Total Contribution', id: 'total contribution'},
    { name: 'Savings Balance', id: 'savings balance'},
]

const CreateCharges = () => {
    const { gl_accounts } = useSelector((state) => state.accounting);

    const multiRef = useRef(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {createSuccess} = useSelector((state) => state.lifecover)


    const breadcrumb = {
        from: {
          title: "Life Cover",
          link: "/admin/settings/life-cover",
        },
        current: {
          title: "Create Life Cover",
          link: null,
        },
    };

    const onSubmit = (values) => {
        let payload = {...values}
        // if (values.claims === 'multiple') {
        //     const multiple = values?.multiple?.map((item) => (
        //         item.value
        //     ));
        
        //     payload = {
        //     ...values,
        //     multiple: [...multiple],
        //     }
        // }else {
        //     payload = {...values, multiple: []}
        // }
        dispatch(createLifeCover(payload));
    };

    
    
    const {
        errors,
        values,
        touched,
        handleBlur,
        handleSubmit,
        handleChange,
        setFieldValue,
        // getFieldProps,
        // setFieldError,
        // resetForm,
      } = useFormik({
        // enableReinitialize: true,
        initialValues: {
          life_cover_name: "",
          policy_category: "2",
          description: "",
        //   termination: "",
        //   withdrawal: "",
        //   maturity: "",
          liability: "",
          asset: "",
          rate: "",
        //   claims: "multiple",
          deduction: "deposit transaction",
        //   multiple: [],
        },
        onSubmit,
        // validate: (values) => {
        //     const errors = {};
        //     if (values?.claims === 'multiple' && !values.multiple) {
        //         errors.multiple = "Atleast one value must be selected";
        //     }
        //     return errors;
        // },
        validationSchema: () =>
            yup.object().shape({
                life_cover_name: yup.string().required("Life Cover Name is required"),
                policy_category: yup.number().required("Policy Category is required"),
                description: yup.string().required("Description is required"),
                // action: yup.string().test('atLeastOneAction', 'At least one action must be filled', function (value) {
                //     const { termination, withdrawal, maturity } = this.parent;
                //     return termination > 0 || withdrawal > 0 || maturity > 0;
                // }),
                liability: yup.number().required("Liability Gl is required"),
                asset: yup.number().required("Asset Gl is required"),
                rate: yup.number().required("Rate is required"),
            }),
        });
    
    useEffect(() => {
        if (createSuccess) {
            navigate("/admin/settings/life-cover")
            dispatch(resetLifeCoverStatus())
        }
        }, [createSuccess, dispatch, navigate])


    const policyData = policies?.map((policy) => {
        return {
            label: policy.name, value: policy.id
        }
    })
  return (
    <div>
        {/* page title */}
        <PageTitle title='Create Life Cover' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row'>
            <div className='col-md-12'>
                <div className='card '>
                    <form onSubmit={handleSubmit}>
                        <div className='row p-3'>
                            <div className='mb-0 col-md-12'>
                                <label htmlFor='inputEmail4' className='form-label'>
                                    Life Cover Name <span className='text-danger'>*</span>
                                </label>
                                <input
                                    name='life_cover_name'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values?.life_cover_name}
                                    type='text'
                                    className={`form-control form-control-sm mb-2`}
                                    placeholder='Life Cover Name'
                                />
                                {errors?.life_cover_name && touched?.life_cover_name && !values?.life_cover_name && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.life_cover_name + '*'}
                                    </p>
                                )}
                            </div>
                            <div className='mb-0 col-md-12'>
                                <label
                                htmlFor='account_type'
                                className={`form-label mt-1`}
                                >
                                Policy Category <span className='text-danger'>*</span>
                                </label>

                                <div className=''>
                                    <Select 
                                        onBlur={() => {
                                            handleBlur({target: {name: 'policy_category'}});
                                        }} 
                                        disabled={true}
                                        name="policy_category" 
                                        data={policyData} 
                                        value={values?.policy_category} 
                                        onChange={(selectedOption) => setFieldValue("policy_category",selectedOption?.value)} 
                                    />
                                    {errors?.policy_category && touched?.policy_category && !values?.policy_category && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.policy_category + '*'}
                                    </p>
                                    )}
                                </div>
                            </div>
                            <div className='mb-0 col-md-12 mt-2'>
                                <label
                                htmlFor='account_type'
                                className={`form-label mt-1`}
                                >
                                Description <span className='text-danger'>*</span>
                                </label>
                                <div className=''>
                                    <textarea
                                        name="description" 
                                        onBlur={handleBlur}
                                        value={values?.description} 
                                        onChange={handleChange} 
                                        className={`form-control`}
                                        placeholder="Description"
                                    />
                                    {errors?.description && touched?.description && !values.description && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.description + '*'}
                                    </p>
                                    )}
                                </div>
                            </div>
                            <div className='mb-0 col-md-12 mt-3'>
                                <label className='form-label my-2'>ACCOUNT</label>
                            </div>
                            <div className='mb-0 col-md-12'>
                                <label
                                htmlFor='account_type'
                                className={`form-label mt-1`}
                                >
                                Asset <span className='text-danger'>*</span>
                                </label>

                                <div className=''>
                                    <Select 
                                        onBlur={() => {
                                            handleBlur({target: {name: 'asset'}});
                                        }} 
                                        name="asset" 
                                        value={values?.asset} 
                                        onChange={(selectedOption) => setFieldValue("asset",selectedOption?.value)}
                                        data={gl_accounts?.accounts?.asset_account?.map((item) => ({
                                            label: item?.account_name,
                                            value: item?.id,
                                        }))} 
                                    />
                                    {errors?.asset && touched?.asset && !values?.asset && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.asset + '*'}
                                    </p>
                                    )}
                                </div>
                            </div>
                            <div className='mb-0 col-md-12'>
                                <label
                                htmlFor='account_type'
                                className={`form-label mt-1`}
                                >
                                Liability <span className='text-danger'>*</span>
                                </label>

                                <div className=''>
                                    <Select 
                                        onBlur={() => {
                                            handleBlur({target: {name: 'liability'}});
                                        }} 
                                        name="liability" 
                                        data={gl_accounts?.accounts?.liability_account?.map((item) => ({
                                            label: item?.account_name,
                                            value: item?.id,
                                        }))} 
                                        value={values?.liability} 
                                        onChange={(selectedOption) => setFieldValue("liability",selectedOption?.value)} 
                                    />
                                    {errors?.liability && touched?.liability && !values?.liability && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.liability + '*'}
                                    </p>
                                    )}
                                </div>
                            </div>
                            <div className='mb-0 col-md-12'>
                                <label htmlFor='inputEmail4' className='form-label mt-3'>
                                    Rate (%) <span className='text-danger'>*</span>
                                </label>
                                <input
                                    name='rate'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values?.rate}
                                    type='text'
                                    className={`form-control form-control-sm mb-2`}
                                    placeholder='Charge Rate'
                                />
                                {errors?.rate && touched?.rate && !values?.rate && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.rate + '*'}
                                    </p>
                                )}
                            </div>
                            <div className='mb-0 col-md-12 mt-3'>
                                <label className='form-label'>Life Cover Deduction</label>
                            </div>
                            <div>
                                <div class='form-check my-1'>
                                    <input
                                    class='form-check-input mx-1'
                                    type='radio'
                                    name='deduction'
                                    id='deduction'
                                    value='deposit transaction'
                                    onChange={handleChange}
                                    defaultChecked={values?.deduction === "deposit transaction"}
                                    />
                                    <label class='form-check-label' for='company_wide'>
                                        Deposit Transaction
                                    </label>
                                </div>
                                <div class='form-check'>
                                    <input
                                    class='form-check-input mx-1'
                                    type='radio'
                                    name='deduction'
                                    value='lumpsum'
                                    onChange={handleChange}
                                    id='deduction'
                                    />
                                    <label class='form-check-label' for='lumpsum'>
                                        Lumpsum
                                    </label>
                                </div>
                            </div>
                            {/* <div className='mb-0 col-md-12 mt-3'>
                                <label className='form-label'>Life Cover Claims</label>
                            </div>
                            <div>
                                <div class='form-check my-1'>
                                    <input
                                    class='form-check-input mx-1'
                                    type='radio'
                                    name='claims'
                                    id='claims'
                                    value='multiple'
                                    onChange={handleChange}
                                    defaultChecked={values?.claims === "multiple"}
                                    />
                                    <label class='form-check-label' for='company_wide'>
                                        Multiple
                                    </label>
                                    {values?.claims === "multiple" && (
                                        <div className='ms-3'>
                                            <MultiSelect
                                            isError={
                                                errors?.multiple
                                            }
                                            name='multiple'
                                            field={{ ...getFieldProps("multiple") }}
                                            data={multipleData?.map((item, i) => ({
                                                label: item?.name,
                                                value: item?.id,
                                            }))}
                                            onChange={setFieldValue}
                                            onBlur={() => {
                                                handleBlur({ target: { name: "multiple" } });
                                            }}
                                            errors={errors}
                                            touched={touched}
                                            disabled={values?.claims !== "multiple"}
                                            ref={multiRef}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div class='form-check'>
                                    <input
                                    class='form-check-input mx-1'
                                    type='radio'
                                    name='claims'
                                    value='assumed_sum_assured'
                                    onChange={handleChange}
                                    id='claims'
                                    />
                                    <label class='form-check-label' for='rab'>
                                        Assumed Sum Assured
                                    </label>
                                </div>
                                <div class='form-check'>
                                    <input
                                    class='form-check-input mx-1'
                                    type='radio'
                                    name='claims'
                                    value='guaranteed_sum_assured'
                                    onChange={handleChange}
                                    id='claims'
                                    />
                                    <label class='form-check-label' for='rab'>
                                        Guaranteed Sum Assured
                                    </label>
                                </div>
                            </div> */}
                            {/* <div className='mb-0 col-md-12 mt-2'>
                                <label
                                    htmlFor='account_type'
                                    className={`form-label mt-1`}
                                    >
                                    Action Applicable <span className='text-danger'>*</span>
                                </label>
                                <div className='mt-2'>
                                    <div className='d-flex align-items-center'>
                                        <label
                                            className='form-label'
                                            htmlFor='superUser'
                                            style={{
                                            // textAlign: "right",
                                            paddingRight: "5px",
                                            marginBottom: "0px",
                                            width: "15%",
                                            }}
                                        >
                                            Termination(%)
                                        </label>
                                        <input
                                            className={`form-control`}
                                            type='number'
                                            value={values?.termination}
                                            name='termination'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            style={{ height: "30px", width: "90px" }}
                                        />
                                    </div>
                                    <div className='d-flex align-items-center pt-1'>
                                        <label
                                            className='form-label'
                                            htmlFor='superUser'
                                            style={{
                                            // textAlign: "right",
                                            paddingRight: "5px",
                                            marginBottom: "0px",
                                            width: "15%",
                                            }}
                                        >
                                            Withdrawal(%)
                                        </label>
                                        <input
                                            className={`form-control`}
                                            type='number'
                                            value={values?.withdrawal}
                                            name='withdrawal'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            style={{ height: "30px", width: "90px" }}
                                        />
                                    </div>
                                    <div className='d-flex align-items-center pt-1'>
                                        <label
                                            className='form-label'
                                            htmlFor='superUser'
                                            style={{
                                            // textAlign: "right",
                                            paddingRight: "5px",
                                            marginBottom: "0px",
                                            width: "15%",
                                            }}
                                        >
                                            Maturity(%)
                                        </label>
                                        <input
                                            className={`form-control`}
                                            type='number'
                                            value={values?.maturity}
                                            name='maturity'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            style={{ height: "30px", width: "90px" }}
                                        />
                                    </div>
                                </div>
                                {errors?.action && (
                                    <p className='mb-0 text-danger'>
                                        {errors?.action + '*'}
                                    </p>
                                )}
                            </div> */}
                            <div className='flex-end mt-3'>
                                <button type='submit' className='btn btn-sm btn-primary px-4'>
                                    Create
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CreateCharges